// flash-notification.ts
import { Component, inject } from '@angular/core';
import { FlashService } from '../../services/flash';

@Component({
  selector: 'app-flash-notification',
  imports: [],
  templateUrl: './flash-notification.html',
  styleUrl: './flash-notification.css',
})
export class FlashNotification {
  protected readonly flashService = inject(FlashService);
  protected readonly flash = this.flashService.state;
}
